import { Direction } from "./types";

export const directionToStylesMap: {
  [key in Direction]: { width: string; height: string };
} = {
  horizontal: {
    width: "100%",
    height: "1px"
  },
  vertical: {
    width: "1px",
    height: "100%"
  }
};
